import { render, staticRenderFns } from "./QuestionRadio.vue?vue&type=template&id=76797bd9&scoped=true&"
import script from "./QuestionRadio.vue?vue&type=script&lang=js&"
export * from "./QuestionRadio.vue?vue&type=script&lang=js&"
import style0 from "./QuestionRadio.vue?vue&type=style&index=0&id=76797bd9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76797bd9",
  null
  
)

export default component.exports